"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageValue = exports.prodAssetsUrl = exports.assetsUrl = exports.TestValue = exports.TestType = exports.TextAlignmentArray = exports.TextAlignment = exports.invertedColorStrategy = exports.MOBILE_PADDING_SIZE = exports.DEFAULT_PADDING_SIZE = exports.alignArray = exports.MobileLayoutsArray = exports.Align = exports.MobileLayouts = exports.DeviceName = exports.Breakpoints = exports.GridBreakpointsMediaDownCustom = exports.GridBreakpointsMaxCustom = exports.ButtonContrast = exports.colorBlackOrWhite = exports.colorContrast = void 0;

var _uiKit = require("@dbi-tools/ui-kit");

var colorContrast = {
  transparent: _uiKit.Colors.white,
  white: _uiKit.Colors.primaryDark,
  black: _uiKit.Colors.white,
  gray100: _uiKit.Colors.primaryDark,
  gray200: _uiKit.Colors.primaryDark,
  gray250: _uiKit.Colors.primaryDark,
  gray300: _uiKit.Colors.primaryDark,
  gray400: _uiKit.Colors.primaryDark,
  gray500: _uiKit.Colors.white,
  gray600: _uiKit.Colors.white,
  gray700: _uiKit.Colors.white,
  gray800: _uiKit.Colors.white,
  begonia: _uiKit.Colors.white,
  wineLight: _uiKit.Colors.white,
  wine: _uiKit.Colors.white,
  primaryLightest: _uiKit.Colors.gray800,
  primaryLighter: _uiKit.Colors.gray800,
  primaryLight: _uiKit.Colors.gray800,
  primary: _uiKit.Colors.white,
  primaryDark: _uiKit.Colors.white,
  secondary: _uiKit.Colors.primaryDark,
  secondaryLight: _uiKit.Colors.primaryDark,
  danger: _uiKit.Colors.white,
  success: _uiKit.Colors.white,
  focus: _uiKit.Colors.white,
  petal: _uiKit.Colors.gray800,
  gem: _uiKit.Colors.white,
  claret: _uiKit.Colors.white,
  spanishCrimson: _uiKit.Colors.white,
  blush: _uiKit.Colors.gray800,
  platinum: _uiKit.Colors.gray700,
  plum: _uiKit.Colors.white
};
exports.colorContrast = colorContrast;
var colorBlackOrWhite = {
  transparent: _uiKit.Colors.white,
  white: _uiKit.Colors.gray800,
  black: _uiKit.Colors.white,
  gray50: _uiKit.Colors.gray800,
  gray100: _uiKit.Colors.gray800,
  gray150: _uiKit.Colors.gray800,
  gray200: _uiKit.Colors.gray800,
  gray250: _uiKit.Colors.gray800,
  gray300: _uiKit.Colors.gray800,
  gray400: _uiKit.Colors.gray800,
  gray500: _uiKit.Colors.white,
  gray600: _uiKit.Colors.white,
  gray700: _uiKit.Colors.white,
  gray800: _uiKit.Colors.white,
  begonia: _uiKit.Colors.white,
  wineLight: _uiKit.Colors.white,
  wine: _uiKit.Colors.white,
  primaryLightest: _uiKit.Colors.gray800,
  primaryLighter: _uiKit.Colors.gray800,
  primaryLight: _uiKit.Colors.gray800,
  primary: _uiKit.Colors.white,
  primaryDark: _uiKit.Colors.white,
  secondary: _uiKit.Colors.gray800,
  secondaryLight: _uiKit.Colors.gray800,
  danger: _uiKit.Colors.white,
  success: _uiKit.Colors.white,
  focus: _uiKit.Colors.white,
  petal: _uiKit.Colors.gray800,
  gem: _uiKit.Colors.white,
  claret: _uiKit.Colors.white,
  spanishCrimson: _uiKit.Colors.white,
  blush: _uiKit.Colors.gray800,
  platinum: _uiKit.Colors.gray700,
  plum: _uiKit.Colors.white
};
exports.colorBlackOrWhite = colorBlackOrWhite;
var ButtonContrast = {
  transparent: 'secondaryLight',
  white: 'gray800',
  black: 'secondaryLight',
  gray50: 'gray800',
  gray100: 'gray800',
  gray150: 'gray800',
  gray200: 'gray800',
  gray250: 'gray800',
  gray300: 'gray800',
  gray400: 'gray800',
  gray500: 'secondaryLight',
  gray600: 'secondaryLight',
  gray700: 'secondaryLight',
  gray800: 'secondaryLight',
  begonia: 'secondaryLight',
  wineLight: 'secondaryLight',
  wine: 'secondaryLight',
  primaryLightest: 'gray800',
  primaryLighter: 'gray800',
  primaryLight: 'gray800',
  primary: 'secondaryLight',
  primaryDark: 'secondaryLight',
  secondary: 'gray800',
  secondaryLight: 'gray800',
  danger: 'secondaryLight',
  success: 'secondaryLight',
  focus: 'secondaryLight',
  petal: 'gray800',
  gem: 'secondaryLight',
  claret: 'secondaryLight',
  spanishCrimson: 'secondaryLight',
  blush: 'gray800',
  platinum: 'gray800',
  plum: 'secondaryLight'
};
exports.ButtonContrast = ButtonContrast;
var GridBreakpointsMaxCustom = {
  xxl: 1920
};
exports.GridBreakpointsMaxCustom = GridBreakpointsMaxCustom;
var GridBreakpointsMediaDownCustom = {
  xxl: "@media (max-width: ".concat(GridBreakpointsMaxCustom.xxl, "px)")
};
exports.GridBreakpointsMediaDownCustom = GridBreakpointsMediaDownCustom;
var Breakpoints;
exports.Breakpoints = Breakpoints;

(function (Breakpoints) {
  Breakpoints["MOBILE"] = "(max-width: 767px)";
  Breakpoints["TABLET"] = "(min-width: 768px) and (max-width: 991px)";
  Breakpoints["DESKTOP"] = "(min-width: 992px)";
})(Breakpoints || (exports.Breakpoints = Breakpoints = {}));

var DeviceName;
exports.DeviceName = DeviceName;

(function (DeviceName) {
  DeviceName["MOBILE"] = "mobile";
  DeviceName["TABLET"] = "tablet";
  DeviceName["DESKTOP"] = "desktop";
})(DeviceName || (exports.DeviceName = DeviceName = {}));

var MobileLayouts;
exports.MobileLayouts = MobileLayouts;

(function (MobileLayouts) {
  MobileLayouts["CAROUSEL"] = "carousel";
  MobileLayouts["SCROLL"] = "scroll";
})(MobileLayouts || (exports.MobileLayouts = MobileLayouts = {}));

var Align;
exports.Align = Align;

(function (Align) {
  Align["LEFT"] = "left";
  Align["CENTER"] = "center";
  Align["RIGHT"] = "right";
})(Align || (exports.Align = Align = {}));

var MobileLayoutsArray = Object.values(MobileLayouts);
exports.MobileLayoutsArray = MobileLayoutsArray;
var alignArray = Object.values(Align);
exports.alignArray = alignArray;
var DEFAULT_PADDING_SIZE = 60;
exports.DEFAULT_PADDING_SIZE = DEFAULT_PADDING_SIZE;
var MOBILE_PADDING_SIZE = 30;
exports.MOBILE_PADDING_SIZE = MOBILE_PADDING_SIZE;
var invertedColorStrategy = {
  transparent: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  white: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  black: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  gray100: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  gray200: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  gray250: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  gray300: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  gray400: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  gray500: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  gray600: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  gray700: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  gray800: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  begonia: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  wineLight: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  wine: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  primaryLightest: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  primaryLighter: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  primaryLight: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  primary: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  primaryDark: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  secondary: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  secondaryLight: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  danger: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  success: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  focus: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  },
  petal: {
    accentColor: 'primaryDark',
    defaultColor: 'gray800',
    buttonColor: 'gray800'
  },
  gem: {
    accentColor: 'white',
    defaultColor: 'white',
    buttonColor: 'white'
  }
};
exports.invertedColorStrategy = invertedColorStrategy;
var TextAlignment;
exports.TextAlignment = TextAlignment;

(function (TextAlignment) {
  TextAlignment["LEFT"] = "left";
  TextAlignment["CENTER"] = "center";
  TextAlignment["RIGHT"] = "right";
  TextAlignment["JUSTIFY"] = "justify";
})(TextAlignment || (exports.TextAlignment = TextAlignment = {}));

var TextAlignmentArray = Object.values(TextAlignment);
exports.TextAlignmentArray = TextAlignmentArray;
var TestType;
exports.TestType = TestType;

(function (TestType) {
  TestType["COMPONENT"] = "component";
  TestType["BLOCK"] = "block";
  TestType["BUTTON"] = "button";
})(TestType || (exports.TestType = TestType = {}));

var TestValue;
exports.TestValue = TestValue;

(function (TestValue) {
  TestValue["AEM_CAROUSEL"] = "aem_carousel";
  TestValue["AEM_CAROUSEL_UI"] = "aem_carousel_ui";
  TestValue["AEM_CAROUSEL_DOT"] = "aem_carousel_dot";
  TestValue["AEM_CAROUSEL_PREV"] = "aem_carousel_prev";
  TestValue["AEM_CAROUSEL_NEXT"] = "aem_carousel_next";
  TestValue["AEM_CAROUSEL_PLAY"] = "aem_carousel_play";
  TestValue["AEM_CAROUSEL_PAUSE"] = "aem_carousel_pause";
  TestValue["AEM_COLOR_CAROUSEL"] = "aem_color_carousel";
  TestValue["AEM_COLOR_CHART"] = "aem_color_chart";
  TestValue["AEM_PALETTE_FILTER"] = "aem_palette_filter";
  TestValue["AEM_FAQ_HUB"] = "aem_faq_hub";
  TestValue["AEM_FEATURE_CARD"] = "aem_feature_card";
  TestValue["AEM_GALLERY"] = "aem_gallery";
  TestValue["AEM_HEADER_TITLES"] = "aem_header_titles";
  TestValue["AEM_HERO_SLIDE_A"] = "aem_hero_slide_a";
  TestValue["AEM_HERO_SLIDE_B"] = "aem_hero_slide_b";
  TestValue["AEM_HERO_SLIDE_VIDEO"] = "aem_hero_slide_video";
  TestValue["AEM_ICON_GRID"] = "aem_icon-grid";
  TestValue["AEM_LINKS_GRID"] = "aem_links-grid";
  TestValue["AEM_MEDIA_PARAGRAPH"] = "aem_media_paragraph";
  TestValue["AEM_PHOTO_LAYOUT"] = "aem_photo_layout";
  TestValue["AEM_PHOTO_LINKS"] = "aem_photo_links";
  TestValue["AEM_PRODUCT_CAROUSEL"] = "aem_product_carousel";
  TestValue["AEM_PROMO"] = "aem_promo";
  TestValue["AEM_QUOTE"] = "aem_quote";
  TestValue["AEM_RESOURCES_COLUMN_LINKS"] = "aem_resources_column_links";
  TestValue["AEM_STORE_LOCATOR"] = "aem_store_locator";
  TestValue["AEM_VARIABLE_COLUMN"] = "aem_variable_column";
  TestValue["AEM_COLUMN_LAYOUT"] = "aem_column_layout";
})(TestValue || (exports.TestValue = TestValue = {}));

var assetsUrl = 'https://d1k0rbiro50qe0.cloudfront.net'; // magento prod media s3 bucket cloudfront domain name

exports.assetsUrl = assetsUrl;
var prodAssetsUrl = 'https://d38sgpcdmo0j0j.cloudfront.net/media';
exports.prodAssetsUrl = prodAssetsUrl;
var LocalStorageValue;
exports.LocalStorageValue = LocalStorageValue;

(function (LocalStorageValue) {
  LocalStorageValue["BACK_URL_AEM"] = "back-url-aem";
})(LocalStorageValue || (exports.LocalStorageValue = LocalStorageValue = {}));